module.exports = new __parcel__URL__("error-darkmode.9dba78cd.svg").toString();